/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Vergleichen lohnt sich – nicht nur für Einkommensmillionäre. Auch eine Doppelverdienerfamilie mit einem Bruttoeinkommen von insgesamt 150'000 Franken wird je nach Gemeinde höchst unterschiedlich besteuert. Am günstigsten kommt die Familie im zugerischen Baar weg. Hier muss sie lediglich 2805 Franken für Kantons-, Gemeinde- und Kirchensteuern zahlen. Deutlich mehr liefert eine solche Familie in den neuenburgischen Gemeinden Les Verrières und Enges ab. Hier werden 20'865 Franken fällig – also mehr als das Siebenfache von Baar.`}</p>
    <p>{`Dies zeigt ein Vergleich der Daten für 2018, welche die eidgenössische Steuerverwaltung kürzlich im Internet veröffentlicht hat. Mit unserer interaktiven Karte können Sie innert weniger Sekunden ermitteln, in welcher Gemeinde Ihr eigener Haushalt am besten wegkommt. Und wie Ihr Wohnort gegenüber den Nachbargemeinden abschneidet.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  